import {useContext, useState} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useLocation} from '@s-ui/react-router'

const DEFAULT_CAPTCHA_RESPONSE = {isActive: false}

const useCaptcha = ({context} = {}) => {
  const {domain} = useContext(Context)
  const {pathname: path} = useLocation()

  const [captchaResponse, setCaptchaResponse] = useState(DEFAULT_CAPTCHA_RESPONSE)

  useMount(async () => {
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    const [getCaptchaStatusError, getCaptchaStatusResponse] = await domain
      .get('get_captcha_status_form_use_case')
      .execute({pageName, context})

    if (getCaptchaStatusError) {
      return setCaptchaResponse(DEFAULT_CAPTCHA_RESPONSE)
    }

    const {siteKey} = getCaptchaStatusResponse
    setCaptchaResponse({isActive: true, siteKey})
  })

  return captchaResponse
}

export {useCaptcha}
